import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';

import { AccountsSelectorComponent } from './accounts-selector/accounts-selector.component';
import { ChannelsNavigationComponent } from './channels-navigation/channels-navigation.component';
import { FiltersComponent } from './filters/filters.component';
import { InboxComponent } from './inbox/inbox.component';
import { InsertsByMeComponent } from './inserts-by-me/inserts-by-me.component';
import { LeftNavigationComponent } from './left-navigation/left-navigation.component';
import { ArchiveDialogComponent } from './mass-actions/archive-dialog/archive-dialog.component';
import { ExportDialogComponent } from './mass-actions/export-dialog/export-dialog.component';
import { MassActionsComponent } from './mass-actions/mass-actions.component';
import { MassAnswerDialogComponent } from './mass-actions/mass-answer-dialog/mass-answer-dialog.component';
import { TabsNavigationComponent } from './tabs-navigation/tabs-navigation.component';
import { AssigneeListPopoverComponent } from './task-actions/assignee-list-popover/assignee-list-popover.component';
import { TaskActionsComponent } from './task-actions/task-actions.component';
import { TaskAttachmentsComponent } from './task-attachments/task-attachments.component';
import { TaskInListComponent } from './task-in-list/task-in-list.component';
import { TaskInfosComponent } from './task-infos/task-infos.component';
import { TaskListSortComponent } from './task-list-sort/task-list-sort.component';
import { TaskListComponent } from './task-list/task-list.component';
import { TaskMessageComponent } from './task-message/task-message.component';
import { TaskSelectionComponent } from './task-selection/task-selection.component';
import { TaskUserComponent } from './task-user/task-user.component';

@NgModule({
  declarations: [
    AccountsSelectorComponent,
    ArchiveDialogComponent,
    AssigneeListPopoverComponent,
    ChannelsNavigationComponent,
    ExportDialogComponent,
    FiltersComponent,
    InboxComponent,
    InsertsByMeComponent,
    LeftNavigationComponent,
    MassActionsComponent,
    MassAnswerDialogComponent,
    TabsNavigationComponent,
    TaskActionsComponent,
    TaskAttachmentsComponent,
    TaskInfosComponent,
    TaskInListComponent,
    TaskListComponent,
    TaskListSortComponent,
    TaskMessageComponent,
    TaskSelectionComponent,
    TaskUserComponent,
  ],
  imports: [CommonModule, SharedModule],
  exports: [ChannelsNavigationComponent, TaskListComponent, TaskListSortComponent],
})
export class InboxModule {}
